import {EXPOSE_TEST} from '../actions/action-types';

export default function mvtReducer(state = {exposed: {}}, action) {
    switch (action.type) {
        case EXPOSE_TEST:
            if (typeof state.exposed[action.testname] !== 'undefined') {
                return state;
            }

            const {testname} = action;
            if (!testname) {
                throw new Error('testname not provided');
            }

            return {
                ...state,
                exposed: {
                    ...state.exposed,
                    [testname]: true
                }
            };
        default:
            return state;
    }
}
